<template lang="html">
  <div class="login">
    <v-row justify=center>
      <v-col cols="10" sm="6" md="4" lg="3">
        <h2>Login</h2>
        <div class="loginForm">
          <v-text-field
            label="username"
            v-model="username"
            autocomplete="off"
          >
          </v-text-field>
          <v-text-field
            label="password"
            v-model="password"
            type="password"
            autocomplete="off"
            @keyup.enter="onSubmit" 
          >
          </v-text-field>
          <v-btn class="primary" @click="onSubmit">Login</v-btn>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data(){
    return{
      username: '',
      password: ''
    }
  },
  methods: {
    onSubmit(){
      const loginFormData ={
        username: this.username,
        password: this.password
      };
      this.$store.dispatch('login',{...loginFormData, router: this.$router});
    }
  }
}
</script>

<style lang="scss" scoped>
.loginForm{
  margin: 40px 0;
  border: 1px solid $lightbrown;
  padding: 30px 30px 80px 30px;

  button{
    margin-top: 15px;
    float: right;
  }
}
</style>
